import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../../../models'
import { daMetricNames } from './da-metric-names'

export const daKeywordMetricNames: Array<TGlobalMetrics> = daMetricNames.filter(
  (header) =>
    !(
      header === EReportColumnHeader.ShareOfVoice ||
      header === EReportColumnHeader.WinRate
    )
)
